export default "__VITE_ASSET__DVWVxuCI__"